import { Box } from "@mui/material"
import type { FC } from "react"

import DisplayAS400Id from "@/components/common/DisplayAS400Id/DisplayAS400Id"
import { StatusIndicator } from "@/components/common/StatusIndicator/StatusIndicator"
import type { GoodsReceiptPallet, Product } from "@/graphql/codegen/graphql"
import { ComputedProductStatusMap } from "@/screens/Companies/products/utils/productStatusMap"

interface GoodsReceiptPalletProductIdCellProps {
  pallet: GoodsReceiptPallet
}

export const GoodsReceiptPalletProductIdCell: FC<GoodsReceiptPalletProductIdCellProps> = ({ pallet }) => {
  const product = pallet.goodsReceiptPalletRow?.product as Product

  return (
    <div className='flex flex-col'>
      <Box className='flex items-center gap-2'>
        <StatusIndicator
          data-testid={`statusIndicator-${product.computedProductStatus}`}
          status={product.computedProductStatus as string}
          map={ComputedProductStatusMap}
        />
        {product.publicId}
      </Box>
      <Box>
        <DisplayAS400Id id={product.externalSystemId} />
      </Box>
    </div>
  )
}
